const apiUrl = process.env.REACT_APP_FLASK_API;
export const fetchCurrentlyPlaying = async () => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_FLASK_API}/currently_playing`,
      {
        credentials: "include",
      }
    );

    if (!response.ok) {
      throw new Error("Failed to fetch currently playing track");
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error in fetchCurrentlyPlaying:", error);
    return null; // Return null instead of throwing error
  }
};
